import { render, staticRenderFns } from "./FilterDescription.vue?vue&type=template&id=3651979f"
import script from "./FilterDescription.vue?vue&type=script&lang=js"
export * from "./FilterDescription.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports